<template lang="html">
  <div class="premade-card start-xs" @click="goToSpecificPremade(premade)">
    <div class="card-body">
      <section class="thumbnail-container">
        <img :src="get_thumbnail_on_amazon_aws" class="thumbnail" />
      </section>
      <section class="card-title">
        <p>{{ premade.title | truncate(61) }}</p>
      </section>
    </div>
    <section class="card-footer flex middle-xs">
      <div class="author-info flex middle-xs pl-caption">
        <img
          :src="premade.author_avatar || 'static/logos/ring.svg'"
          style="margin-right: 9px"
        />
        <span>{{ premade.author_name || 'Parlay' }}</span>
      </div>
    </section>
  </div>
</template>

<script>
  import getFileOnS3 from 'services/amazonAWS/getFileOnS3';
  import URLconfigs from 'services/apiConfigs';

  export default {
    props: {
      premade: {
        type: Object,
        default() {
          return {
            title: null,
            author_avatar: null,
            author_name: null,
          };
        },
      },
      cancelClick: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    data() {
      return {};
    },
    computed: {
      get_thumbnail_on_amazon_aws() {
        if (
          this.premade.thumbnail_url.includes('/static') ||
          this.premade.thumbnail_url.includes('i.vimeocdn')
        )
          return this.premade.thumbnail_url;
        return getFileOnS3(
          '341x192',
          'premade_thumbnails',
          this.premade.thumbnail_url
        );
      },
    },
    methods: {
      goToSpecificPremade(premade) {
        this.cancelClick
          ? null
          : window.open(`${URLconfigs.universeURL}/roundtables/${premade.id}`);
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'

  .premade-card
    border-radius: 2px
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12)
    transition: box-shadow .2s
    &:hover
      cursor: pointer
      box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)
      transition: box-shadow .2s
    @media (max-width: 499px)
      width: 49%
      margin: 0 .5%
    @media (max-width: 799px) and (min-width: 500px)
      width: 32.333333%
      margin: 0 .5%
    @media (max-width: 1099px) and (min-width: 800px)
      width: 24%
      margin: 0 .5%
    @media (max-width: 1399px) and (min-width: 1100px)
      width: 19%
      margin: 0 .5%
    @media (min-width: 1400px)
      width: 15.66666667%
      margin: 0 .5%

  .card-body
    padding: 8px 10px

  .card-title
    width: 95%
    height: 80px

  .card-title p
    margin-top: 7px
    font-weight: bold
    letter-spacing: .01em
    line-height: 22px
    @media (max-width: 799px) and (min-width: 500px)
      font-size: 13px
    @media (max-width: 1099px) and (min-width: 800px)
      font-size: 14px
    @media (max-width: 1399px) and (min-width: 1100px)
      font-size: 15px
    /* comment out for now... this size does not look good in dashboard */
    /* @media (min-width: 1400px)
      font-size: 1.2em */

  .card-subjects
    width: 97%
    height: 37px
    overflow: hidden

  .card-grades
    width: 90%
    height: 30px
    padding: 0 0 0 0

  // Container 16:9
  .thumbnail-container
    position: relative
    width: 100%
    height: 0
    padding: 28.125% 0%
    overflow: hidden
    .thumbnail
      position: absolute
      width: 100%
      top: 0
      bottom: 0
      left: 0
      right: 0

  .card-footer
    border-top: 1px solid pl-fog
    height: 45px
    padding: 3px 10px
    background-color: rgba(241, 241, 241, 0.55)

  .author-info img
    width: 31px
    height: 31px
    border-radius: 50%
</style>



// WEBPACK FOOTER //
// premadeCard.vue?5dffff0d